import React from 'react';

import { useFetchResults } from '../../../../controllers/results';
import { useSpotlightPrefetch } from '../../../../controllers/spotlight';
import { useFeatures } from '../../../../controllers/store';

const FetchResults = () => {
	useFetchResults();
	return null;
};

const SpotlightPrefetch = () => {
	useSpotlightPrefetch();
	return null;
};

export const RegisterHooksWithNewFilters = ({ children }: { children: React.ReactNode }) => {
	const [features] = useFeatures();
	return (
		<React.Fragment>
			{Boolean(features?.fetchInitialResults?.enabled) && <FetchResults />}
			{Boolean(features?.engagement?.enabled) && <SpotlightPrefetch />}
			{children}
		</React.Fragment>
	);
};
